export default {
  admin: {
    chart_data_group: ['global', 'email', 'use', 'technical', 'battery'],
    chart_data_values: {
      global: [
        'visit',
        'email',
        'comment',
        'collected_treasure_count',
        'histopad_rating',
        'visit_rating',
        'histomaton_file',
        'affluence',
        'survey_answer',
        'route_duration',
        'inactivity_time',
      ],
      email: [
        'email_delivered',
        'email_open',
        'email_click',
        'email_delivered_session',
        'email_open_session',
        'email_click_session',
      ],
      use: [
        'hotspot',
        'cartel',
        'immersive',
        'augmentedvisit',
        'interactiveobject',
        'interactivebuilding',
        'sequence',
        'interactivecharacter',
      ],
      technical: ['is_crash', 'duplicate', 'upload', 'rotation', 'stuck_log', 'warning'],
      battery: [
        'max_temperature',
        'min_temperature',
        'max_level',
        'min_level',
        'max_memory_level',
        'min_memory_level',
        'max_temperature_gradient',
        'min_level_gradient',
        'max_memory_level_gradient',
      ],
    },
    chart_data_types: {
      visit: ['count', 'average_count', 'average_time', 'min_time', 'max_time', 'distribution'],
      email: ['count', 'average_count', 'percentage', 'distribution'],
      comment: ['count', 'average_count', 'percentage', 'distribution'],
      collected_treasure_count: ['count', 'average_count', 'distribution'],
      histopad_rating: ['average_count', 'percentage'],
      visit_rating: ['average_count', 'percentage'],
      histomaton_file: ['count', 'average_count', 'percentage', 'distribution'],
      affluence: ['count', 'average_count'],
      uploaded_time: ['count', 'average_count', 'distribution'],
      uploaded_count: ['count', 'average_count', 'distribution', 'percentage'],
      upload: ['count', 'average_count', 'distribution', 'percentage'],
      duplicate: ['count', 'average_count', 'distribution', 'percentage'],
      hotspot: ['count', 'average_count'],
      cartel: ['count', 'average_count', 'average_time'],
      immersive: ['count', 'average_count', 'average_time'],
      augmentedvisit: ['count', 'average_count', 'average_time'],
      interactiveobject: ['count', 'average_count', 'average_time'],
      interactivebuilding: ['count', 'average_count', 'average_time'],
      sequence: ['count', 'average_count', 'average_time'],
      interactivecharacter: ['count', 'average_count', 'average_time'],
      email_delivered: ['count', 'average_count', 'average_time', 'percentage', 'distribution'],
      email_open: ['count', 'average_count', 'average_time', 'percentage', 'distribution'],
      email_click: ['count', 'average_count', 'percentage', 'distribution'],
      email_delivered_session: [
        'count',
        'average_count',
        'average_time',
        'percentage',
        'distribution',
      ],
      email_open_session: ['count', 'average_count', 'average_time', 'percentage', 'distribution'],
      email_click_session: ['count', 'average_count', 'percentage', 'distribution'],
      is_crash: ['count', 'average_count', 'percentage', 'distribution'],
      survey_answer: ['count', 'average_count', 'percentage', 'distribution'],
      rotation: ['average_count'],
      route_duration: ['average_time', 'percentage'],
      inactivity_time: ['average_time', 'percentage'],
      stuck_log: ['count', 'distribution'],
      warning: ['count', 'average_count', 'percentage', 'distribution'],
      max_temperature: ['average_count'],
      min_temperature: ['average_count'],
      max_level: ['average_count'],
      min_level: ['average_count'],
      max_temperature_gradient: ['average_count'],
      min_level_gradient: ['average_count'],
      max_memory_level: ['average_count'],
      min_memory_level: ['average_count'],
      max_memory_level_gradient: ['average_count'],
    },
    chart_distribution_types: {
      visit: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'duration',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      email: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      comment: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      collected_treasure_count: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      histopad_rating: [
        'language',
        'site_location',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      visit_rating: [
        'language',
        'site_location',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      hotspot: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      cartel: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      augmentedvisit: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      interactiveobject: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      interactivebuilding: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      sequence: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      interactivecharacter: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      is_crash: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      uploaded_time: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
      ],
      uploaded_count: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
      ],
      upload: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      duplicate: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
      ],
      histomaton_file: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      affluence: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      email_delivered: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      email_open: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      email_click: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      email_delivered_session: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      email_open_session: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      email_click_session: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      survey_answer: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      rotation: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
      ],
      route_duration: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
      ],
      inactivity_time: [
        'language',
        'histopad_rating',
        'visit_rating',
        'site_location',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      stuck_log: ['site', 'bucket'],
      warning: [
        'warning_type',
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      max_temperature: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      min_temperature: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      max_level: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      min_level: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      max_memory_level: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      min_memory_level: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      max_temperature_gradient: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      min_level_gradient: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
      max_memory_level_gradient: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
        'version',
        'player_version',
        'os_name',
        'os_version',
        'os_build',
        'device_vendor',
        'device_model',
      ],
    },
    charts: {
      count: ['time', 'indicator', 'day'],
      average_count: ['time', 'indicator'],
      average_time: ['time', 'indicator'],
      max_time: ['time', 'indicator'],
      min_time: ['time', 'indicator'],
      percentage: ['time', 'indicator'],
      distribution: ['pie', 'bar'],
    },
    sort_by_values: [
      'all',
      'site_location',
      'language',
      'histopad_rating',
      'visit_rating',
      'collected_treasure_count',
      'product',
      'version',
      'player_version',
      'os_name',
      'os_version',
      'os_build',
      'device_vendor',
      'device_model',
      'site',
      'bucket',
      'warning_type',
    ],
  },
}
